// extracted by mini-css-extract-plugin
export default {"link":"aXuFd54Nl9oGNsY5Sq04"};